module.exports = __webpack_public_path__ + "img/appAsset-brand--Slack.ef01c910.svg";